"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const react_uid_1 = require("react-uid");
const AcceptTermWrapper = styled_components_1.default.div `
  margin-top: 25px;
  font-size: 14px;
  letter-spacing: 0.4px;
`;
const FieldValidationError = styled_components_1.default.div `
  color: #ff0000;
  font-style: italic;

  div::first-letter {
    text-transform: uppercase;
  }
`;
const AcceptTerms = (props) => {
    var _a;
    const { fieldData, onChange } = props;
    const isChecked = String(fieldData.value).toLowerCase() === 'true';
    const handleChange = event => {
        onChange(fieldData, event.target.checked);
    };
    const textsToDisplay = fieldData.label.split(':');
    const primaryText = textsToDisplay[0];
    const secondaryText = (_a = textsToDisplay[1]) === null || _a === void 0 ? void 0 : _a.substring(1);
    return (react_1.default.createElement(AcceptTermWrapper, { className: fieldData.errors && fieldData.errors.length > 0 ? 'field-error' : '' },
        react_1.default.createElement(material_1.Box, null,
            react_1.default.createElement(material_1.List, { sx: { width: '100%' }, subheader: react_1.default.createElement(material_1.ListItemText, { id: "switch-list-label", primary: secondaryText }) },
                react_1.default.createElement(material_1.ListItem, { disablePadding: true },
                    react_1.default.createElement(material_1.Checkbox, { onClick: handleChange, checked: isChecked, inputProps: {
                            'aria-labelledby': 'switch-list-label',
                        } }),
                    fieldData.placeholder ? (react_1.default.createElement(material_1.Link, { href: fieldData.placeholder, target: "_blank", underline: "hover", rel: "noopener" },
                        ' ',
                        primaryText,
                        ' ')) : (react_1.default.createElement(material_1.Typography, null,
                        " ",
                        primaryText,
                        " "))))),
        react_1.default.createElement(material_1.Box, null,
            react_1.default.createElement(FieldValidationError, null, fieldData.errors ? fieldData.errors.map(error => react_1.default.createElement("div", { key: (0, react_uid_1.uid)(error) }, error)) : react_1.default.createElement(react_1.default.Fragment, null)))));
};
exports.default = AcceptTerms;
